module.exports = __webpack_public_path__ + "static/img/1-nei-ying.f10be92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/1-nei-ying.png
// module id = XVdE
// module chunks = 1